import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { fechaHora, poli, subirArchivo, urlArchivo } from './poliApi';

/**
 * Fotos y documentos de una prueba (S-7). Se ven solo a traves de OPEM: el archivo llega descifrado
 * a esta pestana y no queda guardado ni en cache. puedeAdjuntar: cliente o administrador antes de la cita.
 */
const ArchivosPrueba = ({ pruebaId, puedeAdjuntar }) => {
    const entrada = useRef(null);
    const [lista, setLista] = useState([]);
    const [descripcion, setDescripcion] = useState('');
    const [visor, setVisor] = useState(null);
    const [error, setError] = useState('');
    const [ocupado, setOcupado] = useState(false);

    const cargar = useCallback(() => {
        poli(`/pruebas/${pruebaId}/archivos`).then(setLista).catch((e) => setError(e.message));
    }, [pruebaId]);

    useEffect(() => { if (pruebaId) cargar(); }, [pruebaId, cargar]);

    useEffect(() => () => { if (visor) URL.revokeObjectURL(visor.url); }, [visor]);

    const ver = async (a) => {
        setError('');
        try {
            const url = await urlArchivo(a.archivo_id);
            if (a.mime === 'application/pdf') {
                window.open(url, '_blank', 'noopener');
            } else {
                setVisor({ url, titulo: a.etiqueta });
            }
        } catch (e) {
            setError(e.message);
        }
    };

    const adjuntar = async (e) => {
        const f = e.target.files && e.target.files[0];
        e.target.value = '';
        if (!f) return;
        setOcupado(true);
        setError('');
        try {
            await subirArchivo(pruebaId, f, 'ADJUNTO', descripcion || f.name);
            setDescripcion('');
            cargar();
        } catch (err) {
            setError(err.message);
        } finally {
            setOcupado(false);
        }
    };

    return (
        <div>
            <h5 className="mb-2">Fotos y documentos</h5>
            {lista.length === 0 && <small className="text-600">Sin archivos.</small>}
            {lista.map((a) => (
                <div key={a.archivo_id} className="flex align-items-center justify-content-between gap-2 py-1 border-bottom-1 surface-border">
                    <div>
                        <i className={a.tipo === 'FOTO' ? 'pi pi-camera mr-2' : 'pi pi-file mr-2'} />
                        <b>{a.etiqueta}</b> <small className="text-600">· {Math.round(a.tamano / 1024)} KB · {fechaHora(a.fecha_crea)} · {a.usuario}</small>
                    </div>
                    <Button icon="pi pi-eye" className="p-button-text" aria-label={`Ver ${a.etiqueta}`} onClick={() => ver(a)} />
                </div>
            ))}
            {puedeAdjuntar && (
                <div className="flex flex-wrap gap-2 mt-2">
                    <InputText value={descripcion} placeholder="Descripcion del documento (opcional)" aria-label="Descripcion del documento"
                        onChange={(e) => setDescripcion(e.target.value)} style={{ flex: '1 1 14rem' }} />
                    <Button label="Adjuntar documento" icon="pi pi-paperclip" className="p-button-outlined" loading={ocupado} onClick={() => entrada.current.click()} />
                    <input ref={entrada} type="file" accept=".pdf,.jpg,.jpeg,.png" hidden onChange={adjuntar} aria-label="Documento a adjuntar" />
                </div>
            )}
            {error && <Message className="mt-2" severity="error" text={error} />}
            <Dialog header={visor ? visor.titulo : ''} visible={!!visor} style={{ width: 'min(48rem, 95vw)' }} onHide={() => setVisor(null)}>
                {visor && <img src={visor.url} alt={visor.titulo} style={{ maxWidth: '100%' }} />}
            </Dialog>
        </div>
    );
};

export default ArchivosPrueba;
